export const VIEWER_CONSTANT = {
  OFFICE_COUNT: "/office/count",
  OFFICE_COUNT_NEW: "/office/new/count",
  KARYAKARTA_COUNT: "/dashboard/karyakarta/count/true",
  KARYAKARTA_INACTIVE: "/dashboard/karyakarta/count/false",
  REPO_COUNT: "/dashboard/doc/count",
  REPO_COUNT_NEW: "/dashboard/doc/count/recent",
  KIOSK_COUNT: "/dashboard/kiosk/count/true",
  KIOSK_NOT_WORKING_COUNT: "/dashboard/kiosk/count/false",
  COMPLAIN_STATUS_COUNT: "/dashboard/complain/count/status",
  COMPLAIN_CATEGORY_COUNT: "/dashboard/complain/count/category",
  OFFICE_LIST: "/office",
  TOP_KARYAKARTAS: "/user/karyakarta/list",
  RECENT_DOC: "/dashboard/doc/list/recent",
  VIEWER_DATA: "/user",
  USER_CHECK: "/user/check",
  VIEWER_List: "/user/viewer/list",
  TOTAL_COUNT: "/user/viewer/total/count",
  CAST: "/cast",
  BIRTHDAY_COUNT: "/todays-event/count",
};
